module.exports = __webpack_public_path__ + "static/img/messageboard1.37c3ea6b.png";